import { useApiUrlContext } from 'app/Utils/ContextProviders/ApiUrlContextProvider';
import type { StudyProgramVariantAdmissionRequirementsDto } from '~/Features/Api/MyCampusApplication/Models/Dto/Requirements/StudyProgramVariantAdmissionRequirementsDto.csharp';
import { useApiQuery } from '~/Partials/FetchData/Queries/useApiQuery';
import {
    ApplicationDocumentsMasterKey,
    ApplicationDocumentsRetryTimeInMs,
    ApplicationDocumentsStaleTimeInMs,
    DocumentsRequirementsKey,
} from './Utils';

export const useApplicationDocumentsProgramVariantRequirementsQuery = <TData>(
    variantCode: string,
    mapFunction: (response: StudyProgramVariantAdmissionRequirementsDto) => TData,
    options?: { enabled?: boolean }
) => {
    const { getProgramVariantRequirementsUrl } = useApiUrlContext();

    const queryParams: { variantCode: string } = {
        variantCode,
    };

    const result = useApiQuery<StudyProgramVariantAdmissionRequirementsDto>(
        getProgramVariantRequirementsUrl,
        [ApplicationDocumentsMasterKey, DocumentsRequirementsKey, variantCode],
        {
            queryOptions: {
                refetchInterval: ApplicationDocumentsStaleTimeInMs,
                staleTime: ApplicationDocumentsStaleTimeInMs,
                retryDelay: ApplicationDocumentsRetryTimeInMs,
                enabled: options?.enabled,
            },
            queryParams,
        }
    );

    return {
        isLoading: result.isLoading,
        hasError: result.hasError,
        requirements: result.data && mapFunction(result.data),
    };
};
